import DashboardWidget from "./DashboardWidget";

export default DashboardWidget;
